import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  DefaultTitle,
  DefaultSubtitle,
  Link,
  PolicyTable,
  JudgeQuoteContainer
} from 'src/components/application/defaultComponents'
import ApplicationPrebuiltFooter from 'src/components/application/PrebuiltBodyFooter'
import { useApplication } from 'src/context/application'
import { tlieSources } from 'src/constants/tlie'
import ApplicationData from 'src/dtos/applicationData'

const Details = () => {
  const { application } = useApplication()

  const updatedApplication: ApplicationData = {
    ...application,
    judgeApplicationData: {
      ...application?.judgeApplicationData,
      quoteData: {
        quotes: [{
          liabilityLimits: '1000000;1000000',
          deductible: '1k'
        }]
      }
    }
  }

  const goBackRoute = () => {
    if(application?.judgeApplicationData?.insuranceSection?.pastLiability?.hasActsToBaseClaim === true || 
      application?.judgeApplicationData?.insuranceSection?.pastLiability?.hasClaimsAsserted === true
    ) {
      return '/judge/insurance/claims'
    }
    if(application?.judgeApplicationData?.insuranceSection?.hasBeenInsuredRecently === true) {
      return "/judge/insurance/past-liability"
    }
    return '/judge/insurance/last-insurances'
  }
  
  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent width='80%'>
        <DefaultTitle>Quote Details</DefaultTitle>
        <DefaultSubtitle>See the details below for information and coverage of the Judge’s Policy.</DefaultSubtitle>
        <JudgeQuoteContainer>
          <h5>Judges’ Policy</h5>
          <p>
            All TLIE Judges' Professional Liability Insurance Policies have a limit of $1,000,000 per claim and a $1,000,000 aggregate, 
            with a $1,000 aggregate deductible. Please note that a policy will not go into effect unless you have satisfied the 
            Association's underwriting  requirements. The TLIE policy for judges does not cover acts, errors or omissions of 
            applicant in practicing law as an attorney. If applicant has previously had a private practice or continues some 
            private practice, TLIE recommends purchasing a "claims made and reported" policy for attorneys in addition to a judges policy.
          </p>
          <PolicyTable style={{marginTop: '66px'}}>
            <tbody>
              <tr>
                <td>Limits of Liability</td>
                <td>$1,000,000 per claim and aggregate</td>
              </tr>
              <tr>
                <td>Deductible</td>
                <td>$1,000 aggregate</td>
              </tr>
            </tbody>
          </PolicyTable>
          <Link
            href={tlieSources.quotePolicyJudge}
            target="_blank"
            rel="noreferrer noopener"
            style={{ fontSize: '12px' }}
          >
            Review the full details of the Judges Policy here.
          </Link>
        </JudgeQuoteContainer>
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute={goBackRoute()}
        nextRoute="/judge/review/basic"
        updatedApplication={updatedApplication}
      />
    </ApplicationBodyContainer>
  )
}

export default Details